module.exports = __webpack_public_path__ + "static/desktop-dashboard-x2-a255dd85693236e3ca4ff3e33e479085.png";